import { useSyncExternalStore } from 'react';
import {
  getInterviewerTimezoneVersion,
  subscribeInterviewerTimezones,
} from './interviewerTimezoneStore';

/**
 * Re-renders the caller whenever an interviewer timezone is set this session.
 *
 * Read the returned version in a component that renders a timezone-derived
 * affordance (and list it in the deps of any memoised renderer), so the chip
 * repaints the moment the modal saves — no refetch, no remount.
 */
export const useInterviewerTimezoneOverrides = (): number =>
  useSyncExternalStore(
    subscribeInterviewerTimezones,
    getInterviewerTimezoneVersion,
    getInterviewerTimezoneVersion
  );
